import React from "react";

export const WithdrawCardInfo = () => (
    <React.Fragment>

        <section id="BenefitCardInfo" className={` bg-orange-50 text-white font-sans flex flex-col lg:flex-row`}>
            <div className="mt-20 w-full flex items-center justify-center">
                <div className="max-w-1/2 p-8 lg:pl-20 flex flex-col justify-center gap-5">
                    <div className="w-full flex items-center justify-center">
                        <div className="p-5">
                            <h1 className="text-gray-800 text-4xl lg:text-3xl font-bold leading-tight mb-4">
                                Saque do Limite do Cartão Consignado BM <br />
                                <small className="text-gray-800 text-sm">
                                    Transforme o limite do seu cartão consignado em dinheiro na conta com rapidez e segurança.
                                </small>
                            </h1>
                            <p className="text-gray-800 text-sm mb-4">
                                💳 O saque do limite do cartão de crédito consignado BMG permite que você transforme parte do limite<br></br> do seu cartão em dinheiro direto na sua conta, de forma rápida, prática e com taxas de juros mais baixas<br />do que outros tipos de crédito.
                            </p>

                            <ul className="text-gray-800 mb-6 space-y-2">
                                <li className="text-gray-800">✔ Dinheiro cai na conta em poucas horas ou até 1 dia útil</li>
                                <li className="text-gray-800">✔ Taxas de juros mais baixas que empréstimos pessoais</li>
                                <li className="text-gray-800">✔ Parte do pagamento é descontada direto do benefício ou salário</li>
                                <li className="text-gray-800">✔ Não precisa de nova análise de crédito nem consulta ao SPC/Serasa</li>
                            </ul>
                        </div>
                        <img className="hidden bg-[#FA6300] rounded-full md:block w-[350px]" src="/assets/mulher-segurando-cartao_2.png" alt="hero-benefit-blocked" />
                    </div>
                </div>
            </div>
        </section>
        <section className="bg-orange-600 text-white py-12 px-6 text-center">
            <h1 className="text-3xl md:text-4xl font-bold">Saque do Limite do Cartão Consignado BMG</h1>
            <p className="mt-2 text-lg max-w-2xl mx-auto">
                Transforme o limite do seu cartão consignado em dinheiro na conta com rapidez e segurança.
            </p>
        </section>
    </React.Fragment>
); 